import * as React from "react";
export var OddsUpdateArrowIndicatorAnimation;
(function (OddsUpdateArrowIndicatorAnimation) {
    OddsUpdateArrowIndicatorAnimation["OddsIncrement"] = "rj-odds-update-arrow-indicator--up-animated";
    OddsUpdateArrowIndicatorAnimation["OddsDecrement"] = "rj-odds-update-arrow-indicator--down-animated";
})(OddsUpdateArrowIndicatorAnimation || (OddsUpdateArrowIndicatorAnimation = {}));
export class OddsUpdateArrowIndicator extends React.Component {
    constructor() {
        super(...arguments);
        this.spanOddsIncrease = React.createRef();
        this.spanOddsDecrease = React.createRef();
        this.addClass = (ref, className) => {
            if (ref.current) {
                ref.current.classList.add(className);
            }
        };
        this.removeClass = (ref, className) => {
            if (ref.current) {
                ref.current.classList.remove(className);
            }
        };
        this.handleIncreaseAnimationEnd = () => {
            this.removeClass(this.spanOddsIncrease, OddsUpdateArrowIndicatorAnimation.OddsIncrement);
        };
        this.handleDecreaseAnimationEnd = () => {
            this.removeClass(this.spanOddsDecrease, OddsUpdateArrowIndicatorAnimation.OddsDecrement);
        };
    }
    shouldComponentUpdate(nextProps) {
        if (this.props.odds > nextProps.odds) {
            this.addClass(this.spanOddsDecrease, OddsUpdateArrowIndicatorAnimation.OddsDecrement);
        }
        if (this.props.odds < nextProps.odds) {
            this.addClass(this.spanOddsIncrease, OddsUpdateArrowIndicatorAnimation.OddsIncrement);
        }
        return false;
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { ref: this.spanOddsIncrease, onAnimationEnd: this.handleIncreaseAnimationEnd, className: "rj-odds-update-arrow-indicator rj-odds-update-arrow-indicator--up" }),
            React.createElement("span", { ref: this.spanOddsDecrease, onAnimationEnd: this.handleDecreaseAnimationEnd, className: "rj-odds-update-arrow-indicator rj-odds-update-arrow-indicator--down" })));
    }
}
//# sourceMappingURL=OddsUpdateArrowIndicator.js.map